import { ConcreteEncodable } from "./ConcreteEncodable";

import { AutoHedgingStatusImplEncoder } from "../../encoder/AutoHedgingStatusImplEncoder";

import * as CubiqTS from "../../index";
import { AutoHedgingStatus } from "../AutoHedgingStatus";

export class AutoHedgingStatusImpl extends ConcreteEncodable implements AutoHedgingStatus {
  public static enType: string = "com.bcdfx.model.AutoHedgingStatusImpl";

  /*FID=1*/
  public autoHedgingEnabled: boolean;
  /*FID=2*/
  public userId: CubiqTS.Long | null = null;
  /*FID=3*/
  public timestamp: CubiqTS.moment.Moment | null = null;
  /*FID=4*/
  public comment: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = AutoHedgingStatusImplEncoder.Instance;
    this.setEncodableType(AutoHedgingStatusImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "AutoHedgingStatusImpl[" +
      "autoHedgingEnabled=" +
      this.autoHedgingEnabled +
      "userId=" +
      this.userId +
      "timestamp=" +
      this.timestamp +
      "comment=" +
      this.comment +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
